import {
  ComponentTreeNode,
  isTextTreeNode,
} from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { stripLinksFromRichText } from '../../richtext/ast';

/**
 * Recursively strip all links from Text nodes within a tree node and its children
 * @param node The ComponentTreeNode to process
 * @returns A new node with links stripped from all Text nodes
 */
export function stripLinksFromTreeNode(node: ComponentTreeNode): ComponentTreeNode {
  let processedNode = node;

  if (isTextTreeNode(node) && typeof node.data.text !== 'string') {
    processedNode = {
      ...node,
      data: {
        ...node.data,
        text: stripLinksFromRichText(node.data.text),
      },
    };
  }

  if ('children' in processedNode && Array.isArray(processedNode.children)) {
    return {
      ...processedNode,
      children: processedNode.children.map((child) => stripLinksFromTreeNode(child)),
    } as ComponentTreeNode;
  }

  return processedNode;
}
